<div class="topic-full-screen-content">
    <div class="topic-full-screen-header">
        <div class="topic-full-screen-header__top-row">
            <topic-type class="topic-full-screen-header__topic-type"
                        [itemList]="globalTablesService.getListItemsForField(pstFieldNames.PSTTopicType)"
                        [labelTranslationPrefix]="topicTypeTranslationLabelPrefix"
                        [required]="globalTablesService?.FieldDefsDict[pstFieldNames?.PSTTopicType]?.Required"
                        [label]="globalTablesService?.FieldDefsDict[pstFieldNames?.PSTTopicType]?.DefaultCaption"
                        (changed)="updateTopic($event, pstFieldNames.PSTTopicType)"
                        showAdd
                        showRemove
                        [maxValuesToShow]="10"
                        [disabled]="topicDisabled || data.readOnlyCriteria[pstFieldNames?.PSTTopicType]"
                        [value]="data?.topicType">
            </topic-type>
            <button class="topic-full-screen-header-close-button"
                    [matTooltip]="languageSettings.PSTWebCloseButtonLabel"
                    (click)="close.emit()"
                    mat-icon-button>
                <mat-icon>close</mat-icon>
            </button>
        </div>
        <div class="topic-full-screen-header__text">
            <st-text-area-overlay required
                                  #slug
                                  minRows="1"
                                  minHeight="1.75rem"
                                  [textToHighlight]="searchString"
                                  class="topic-full-screen-header__title"
                                  panelClass="topic-full-screen-header__title"
                                  [value]="data?.topicSlug"
                                  maxLength="50"
                                  disableNewLine
                                  [disabled]="topicDisabled"
                                  (changed)="updateTopic($event, pstFieldNames.PSTTopicSlug)"
                                  [label]="languageSettings.PSTWebSlugPlaceholder"
                                  [placeholder]="languageSettings.PSTWebSlugPlaceholder"></st-text-area-overlay>

            <st-text-area-overlay class="topic-full-screen-header__description"
                                  panelClass="topic-full-screen-header__description"
                                  minRows="3"
                                  minHeight="1rem"
                                  [textToHighlight]="searchString"
                                  [value]="data?.summary"
                                  [disabled]="topicDisabled"
                                  (changed)="updateTopic($event, pstFieldNames.PSTTopicSummary)"
                                  [required]="globalTablesService?.FieldDefsDict[pstFieldNames?.PSTTopicSummary]?.Required"
                                  [placeholder]="globalTablesService?.FieldDefsDict[pstFieldNames?.PSTTopicSummary]?.DefaultCaption"
                                  [label]="globalTablesService?.FieldDefsDict[pstFieldNames?.PSTTopicSummary]?.DefaultCaption"></st-text-area-overlay>
        </div>
    </div>

    <div class="topic-full-screen-main-content"
         [dir]="isRTL">
        <div class="topic-full-screen-meta">
            <div class="topic-full-screen-meta-border-left"
                 leftBorder
                 [record]="data"></div>
            <date-time-picker class="topic-full-screen-meta__date-picker"
                              *ngIf="globalTablesService.FieldDefsDict[pstFieldNames?.PSTTopicFileDate]?.Validation?.toUpperCase() == fieldDefValidations.TIME; else datePicker"
                              [required]="enforceRequiredFieldsOnCreate && globalTablesService.FieldDefsDict[pstFieldNames?.PSTTopicFileDate]?.Required"
                              [label]="globalTablesService.FieldDefsDict[pstFieldNames?.PSTTopicFileDate]?.DefaultCaption"
                              (changed)="updateTopic($event, pstFieldNames.PSTTopicFileDate)"
                              [disabled]="topicDisabled || data.readOnlyCriteria[pstFieldNames?.PSTTopicFileDate]"
                              [value]="getDateTimeValue(pstFieldNames.PSTTopicFileDate)">
            </date-time-picker>
            <ng-template #datePicker>
                <date-picker class="topic-full-screen-meta__date-picker"
                             [required]="enforceRequiredFieldsOnCreate && globalTablesService.FieldDefsDict[pstFieldNames?.PSTTopicFileDate]?.Required"
                             [label]="globalTablesService.FieldDefsDict[pstFieldNames?.PSTTopicFileDate]?.DefaultCaption"
                             (changed)="updateTopic($event, pstFieldNames.PSTTopicFileDate)"
                             [disabled]="topicDisabled || data.readOnlyCriteria[pstFieldNames?.PSTTopicFileDate]"
                             [value]="getDateTimeValue(pstFieldNames.PSTTopicFileDate)">
                </date-picker>
            </ng-template>
            <div class="topic-full-screen-meta-right">
                <status class="topic-full-screen-header-meta__status"
                        [value]="data.status"
                        [required]="enforceRequiredFieldsOnCreate && globalTablesService.FieldDefsDict[pstFieldNames?.PSTTopicStatus]?.Required"
                        (changed)="updateTopic($event, pstFieldNames.PSTTopicStatus)"
                        [disabled]="topicDisabled || data.readOnlyCriteria[pstFieldNames?.PSTTopicStatus]"
                        [placeholder]="globalTablesService.FieldDefsDict[pstFieldNames?.PSTTopicStatus]?.DefaultCaption"
                        [itemList]="globalTablesService.getListItemsForField(pstFieldNames.PSTTopicStatus)">
                </status>
                <button class="topic-full-screen-meta__approve"
                        [disabled]="topicDisabled || data.readOnlyCriteria[pstFieldNames?.PSTApproved]"
                        *ngIf="globalTablesService.FieldDefsDict[pstFieldNames?.PSTApproved]?.TopicProp && !topicDisabled"
                        [matTooltip]="globalTablesService.FieldDefsDict[pstFieldNames?.PSTApproved]?.DefaultCaption"
                        (click)="updateTopic(!data.pstApproved, pstFieldNames.PSTApproved)"
                        [class.topic-full-screen-meta__approve--active]="data.pstApproved"
                        mat-icon-button>
                    <mat-icon>done</mat-icon>
                </button>
                <button class="topic-full-screen-meta__actions"
                        mat-icon-button
                        #trigger="cdkOverlayOrigin"
                        cdkOverlayOrigin
                        [disabled]="topicDisabled"
                        (click)="externalActionsClick()">
                    <mat-icon>more_vert</mat-icon></button>
                <ng-template #externalActions>
                    <ng-template cdkConnectedOverlay
                                 [cdkConnectedOverlayOrigin]="trigger"
                                 [cdkConnectedOverlayOpen]="isPanelOpen"
                                 (overlayOutsideClick)="isPanelOpen = false">
                        <external-actions-overlay [data]="data"
                                                  inFullScreen
                                                  [editable]="topicEditable"
                                                  [isPanelOpen]="isPanelOpen"
                                                  [onObjectOpen]="onTopicOpen"
                                                  [onDelete]="close"
                                                  (onActionClick)="isPanelOpen = false">
                        </external-actions-overlay>
                    </ng-template>
                </ng-template>
            </div>
        </div>
        <ng-template [ngIf]="customCardItems?.length> 0">

            <div class="topic-full-screen-accordion-pane-container-property-group__container">
                <div class="topic-full-screen-accordion-pane-container-property-group">
                    <ng-template ngFor
                                 let-idx
                                 [ngForOf]="[0, 1, 2, 3]">
                        <ng-container *ngIf="customCardItems[idx]"
                                      [ngTemplateOutlet]="groupingTemplate"
                                      [ngTemplateOutletContext]="{ item: customCardItems[idx], data: data, isCustom: true }">
                        </ng-container>
                    </ng-template>
                </div>
            </div>
        </ng-template>
        <div class="topic-full-screen-tags">
            <div class="topic-full-screen-tags-label">
                <mat-icon class="topic-full-screen-tags__icon">
                    tag
                </mat-icon>
                <span>{{globalTablesService.FieldDefsDict[pstFieldNames.PSTTopicTag]?.DefaultCaption}}</span>
            </div>
            <tags-autocomplete [value]="data?.tags"
                               (changed)="updateTopic($event, pstFieldNames.PSTTopicTag)"
                               maxItemsToShow="100"
                               [disabled]="topicDisabled || data.readOnlyCriteria[pstFieldNames?.PSTTopicTag]"
                               [required]="enforceRequiredFieldsOnCreate && globalTablesService.FieldDefsDict[pstFieldNames?.PSTTopicTag]?.Required"
                               [label]="globalTablesService.FieldDefsDict[pstFieldNames?.PSTTopicTag]?.DefaultCaption">
            </tags-autocomplete>
        </div>
        <div class="topic-full-screen-owners">
            <div class="topic-full-screen-owners-label">
                <mat-icon class="topic-full-screen-owners__icon">
                    assignment_ind
                </mat-icon>
                <span>{{globalTablesService.FieldDefsDict[pstFieldNames?.PSTTopicStoryOwner]?.DefaultCaption}}</span>
            </div>
            <staff-id-list-multiple [value]="data?.storyOwner"
                                    [disabled]="topicDisabled || data.readOnlyCriteria[pstFieldNames?.PSTTopicStoryOwner]"
                                    (changed)="updateTopic($event, pstFieldNames.PSTTopicStoryOwner)"
                                    [required]="enforceRequiredFieldsOnCreate && globalTablesService.FieldDefsDict[pstFieldNames?.PSTTopicStoryOwner]?.Required"
                                    [label]="globalTablesService.FieldDefsDict[pstFieldNames?.PSTTopicStoryOwner]?.DefaultCaption">
            </staff-id-list-multiple>
        </div>
        <div class="topic-full-screen-desks">
            <div class="topic-full-screen-desks-label">
                <mat-icon class="topic-full-screen-desks__icon">
                    apartment
                </mat-icon>
                <span>{{globalTablesService.FieldDefsDict[pstFieldNames.PSTTopicDepartment]?.DefaultCaption}}</span>
            </div>
            <check-list [value]="data?.department"
                        [disabled]="topicDisabled || data.readOnlyCriteria[pstFieldNames?.PSTTopicDepartment]"
                        (changed)="updateTopic($event, pstFieldNames.PSTTopicDepartment)"
                        [itemList]="globalTablesService.getListItemsForDesk(data?.type)"
                        [required]="enforceRequiredFieldsOnCreate && globalTablesService.FieldDefsDict[pstFieldNames?.PSTTopicDepartment]?.Required"
                        [label]="globalTablesService.FieldDefsDict[pstFieldNames?.PSTTopicDepartment]?.DefaultCaption">
            </check-list>
        </div>

        <mat-accordion class="topic-full-screen-accordion"
                       #accordion
                       multi>
            <ng-template ngFor
                         let-group
                         [ngForOf]="groups"
                         let-i="index">
                <ng-container [ngSwitch]="group.dynamic">
                    <ng-template [ngSwitchCase]="false">
                        <ng-container [ngSwitch]="group.name">
                            <ng-template [ngSwitchCase]="languageSettings.PSTWebAttachmentsPane">
                                <pane-container *ngIf="showAttachments && !topicDisabled"
                                                #paneContainer
                                                class="topic-full-screen-accordion-pane-container"
                                                [title]="attachmentsFiedGroupLabel"
                                                [expanded]="visualStateService.expanderSettingsMap['TOPICITEM']?.[attachmentsFiedGroupLabel]"
                                                (panelStateChanged)="panelStateChanged($event, 'TOPICITEM', attachmentsFiedGroupLabel)">
                                    <span title>{{attachmentsFiedGroupLabel}}</span>
                                    <attachments-list [record]="data"
                                                      [property]="pstFieldNames.PSTExternalFiles"
                                                      securityPrivilegeObject="topic">
                                    </attachments-list>
                                    <ng-container actions>
                                        <button mat-icon-button
                                                (click)="expandCollapseAll(paneContainer)"
                                                class="topic-full-screen-accordion-pane-container-expand-collapse"
                                                [matTooltip]="paneContainer?.expanded ? collapseAllLabel : expandAllLabel"
                                                click-stop-propagation>
                                            <mat-icon fontSet="material-symbols-outlined">
                                                {{paneContainer?.expanded ? 'collapse_all' : 'expand_all'}}
                                            </mat-icon>
                                        </button>
                                    </ng-container>
                                </pane-container>
                            </ng-template>

                            <ng-template [ngSwitchCase]="languageSettings.PSTWebCoverageAssignmentsPane">
                                <pane-container #paneContainer
                                                *ngIf="assignmentsReadable"
                                                class="topic-full-screen-accordion-pane-container"
                                                [expanded]="visualStateService.expanderSettingsMap['TOPICITEM']?.[coverageAssignmentsFiedGroupLabel]"
                                                (panelStateChanged)="panelStateChanged($event, 'TOPICITEM', coverageAssignmentsFiedGroupLabel)"
                                                [class.topic-full-screen-required]="enforceRequiredFieldsOnCreate && !data.requiredFieldsGroups['Assignments']">
                                    <span title>{{coverageAssignmentsFiedGroupLabel}}</span>

                                    <ng-container actions>
                                        <div class="topic-full-screen-accordion-pane-container-assignment-actions">
                                            <button mat-flat-button
                                                    [disabled]="topicDisabled"
                                                    class="topic-full-screen-accordion-pane-container-btn__add"
                                                    [matMenuTriggerFor]="assignmentsMenu"
                                                    click-stop-propagation>
                                                <mat-icon>
                                                    add
                                                </mat-icon>
                                                {{languageSettings.PSTWebAssignmentAddLabel}}
                                            </button>
                                            <mat-menu #assignmentsMenu="matMenu"
                                                      click-stop-propagation>
                                                <mat-selection-list hideSingleSelectionIndicator
                                                                    [multiple]="false">
                                                    <mat-list-option *ngFor="let item of assignmentTypes"
                                                                     (click)="createAssignment(item.id)"
                                                                     click-stop-propagation
                                                                     [dir]="isRTL"
                                                                     [value]="item.id">
                                                        <icon matListItemIcon
                                                              [type]="item.id"></icon>
                                                        <div matListItemTitle>{{item.title}}</div>
                                                    </mat-list-option>
                                                </mat-selection-list>
                                            </mat-menu>

                                            <button mat-icon-button
                                                    (click)="expandCollapseAll(paneContainer)"
                                                    class="topic-full-screen-accordion-pane-container-expand-collapse"
                                                    [matTooltip]="paneContainer?.expanded ? collapseAllLabel : expandAllLabel"
                                                    click-stop-propagation>
                                                <mat-icon fontSet="material-symbols-outlined">
                                                    {{paneContainer?.expanded ? 'collapse_all' : 'expand_all'}}
                                                </mat-icon>
                                            </button>
                                        </div>
                                    </ng-container>
                                    <ng-container *ngFor="let item of data?.children; let i = index">
                                        <assignment [data]="item"
                                                    [selected]="selectedAssignmentIndex == i"
                                                    inFullscreenMode
                                                    (assignmentDeleted)="onAssignmentDelete.emit($event)"
                                                    (assignmentOpened)="onAssignmentOpenHandler(i)">
                                        </assignment>
                                    </ng-container>
                                </pane-container>
                            </ng-template>


                            <ng-template ngSwitchDefault
                                         ngFor
                                         let-item
                                         [ngForOf]="specialProps"
                                         let-i="index">
                                <pane-container *ngIf="item?.Validation?.toUpperCase() == fieldDefValidations.SPECIAL && group.name == item.DefaultCaption"
                                                #paneContainer
                                                class="topic-full-screen-accordion-pane-container"
                                                [expanded]="visualStateService.expanderSettingsMap['TOPICITEM']?.[item?.DefaultCaption]"
                                                (panelStateChanged)="panelStateChanged($event, 'TOPICITEM', item.DefaultCaption)">
                                    <span title>{{item.DefaultCaption}}</span>
                                    <ng-container actions>
                                        <button mat-icon-button
                                                (click)="expandCollapseAll(paneContainer)"
                                                class="topic-full-screen-accordion-pane-container-expand-collapse"
                                                [matTooltip]="paneContainer?.expanded ? collapseAllLabel : expandAllLabel"
                                                click-stop-propagation>
                                            <mat-icon fontSet="material-symbols-outlined">
                                                {{paneContainer?.expanded ? 'collapse_all' : 'expand_all'}}
                                            </mat-icon>
                                        </button>
                                    </ng-container>
                                    <special [value]="getValue(item.ID, item.Validation)"
                                             (changed)="updateTopic($event, item.ID)"
                                             [disabled]="topicDisabled"
                                             [columns]="globalTablesService.getListColumnsForSpecialField(item.ID)">
                                    </special>
                                </pane-container>
                                <pane-container *ngIf="item?.Validation?.toUpperCase() == fieldDefValidations.COST && group.name == item.DefaultCaption"
                                                #paneContainer
                                                class="topic-full-screen-accordion-pane-container"
                                                [expanded]="visualStateService.expanderSettingsMap['TOPICITEM']?.[item?.DefaultCaption]"
                                                (panelStateChanged)="panelStateChanged($event, 'TOPICITEM', item?.DefaultCaption)">
                                    <span title>{{item.DefaultCaption}}</span>
                                    <ng-container actions>
                                        <button mat-icon-button
                                                (click)="expandCollapseAll(paneContainer)"
                                                class="topic-full-screen-accordion-pane-container-expand-collapse"
                                                [matTooltip]="paneContainer?.expanded ? collapseAllLabel : expandAllLabel"
                                                click-stop-propagation>
                                            <mat-icon fontSet="material-symbols-outlined">
                                                {{paneContainer?.expanded ? 'collapse_all' : 'expand_all'}}
                                            </mat-icon>
                                        </button>
                                    </ng-container>
                                    <special-cost [required]="enforceRequiredFieldsOnCreate && item.Required"
                                                  [value]="getValue(item.ID, item.Validation)"
                                                  (changed)="updateTopic($event, item.ID)"
                                                  [disabled]="topicDisabled"
                                                  [columns]="globalTablesService.getListColumnsForSpecialField(item.ID)"></special-cost>
                                </pane-container>
                            </ng-template>
                        </ng-container>
                    </ng-template>
                    <ng-template ngSwitchDefault>
                        <pane-container *ngIf="data.visibilityCriteriaGroups[group?.name]"
                                        #paneContainer
                                        class="topic-full-screen-accordion-pane-container"
                                        [expanded]="visualStateService.expanderSettingsMap['TOPICITEM']?.[getFieldGroupsLabel(group)]"
                                        (panelStateChanged)="panelStateChanged($event, 'TOPICITEM', getFieldGroupsLabel(group))"
                                        [class.topic-full-screen-required]="enforceRequiredFieldsOnCreate && !data.requiredFieldsGroups[group?.name]">
                            <span title>
                                {{getFieldGroupsLabel(group)}}
                            </span>
                            <ng-container actions>
                                <button mat-icon-button
                                        (click)="expandCollapseAll(paneContainer)"
                                        class="topic-full-screen-accordion-pane-container-expand-collapse"
                                        [matTooltip]="paneContainer?.expanded ? collapseAllLabel : expandAllLabel"
                                        click-stop-propagation>
                                    <mat-icon fontSet="material-symbols-outlined">
                                        {{paneContainer?.expanded ? 'collapse_all' : 'expand_all'}}
                                    </mat-icon>
                                </button>
                            </ng-container>
                            <div class="topic-full-screen-accordion-pane-container-property-group__container">
                                <div class="topic-full-screen-accordion-pane-container-property-group">
                                    <ng-container [ngTemplateOutlet]="groupingTemplate"
                                                  [ngTemplateOutletContext]="{ data: data, isCustom: false, group: group }">
                                    </ng-container>
                                </div>
                            </div>
                        </pane-container>
                    </ng-template>
                </ng-container>
            </ng-template>
        </mat-accordion>
    </div>

</div>
<div class="topic-full-screen-create-footer"
     *ngIf="isCreate">
    <mat-divider></mat-divider>
    <div class="topic-full-screen-create-footer-buttons">
        <button mat-button
                (click)="close.emit()">
            {{languageSettings.PSTWebCloseButtonLabel}}
        </button>
        <button (click)="create(false)"
                [disabled]="disabled"
                mat-button
                matRipple
                [matRippleRadius]="15">
            <ng-template [ngIf]="!loading"
                         [ngIfElse]="loader">
                {{languageSettings.PSTWebSaveButtonLabel}}
            </ng-template>
        </button>
        <button mat-button
                (click)="create(true)"
                [disabled]="disabled"
                color="primary">
            <ng-template [ngIf]="!loadingSaveAndNext"
                         [ngIfElse]="loader">
                {{languageSettings.PSTWebSaveAndNextButtonLabel}}
            </ng-template>
        </button>
    </div>
</div>

<ng-template #loader>
    <loader [diameter]="30"
            class="topic-full-screen-create-footer-buttons--spinner"
            [strokeWidth]="5"></loader>
</ng-template>
<ng-template #groupingTemplate
             let-group="group"
             let-item="item"
             let-validation="validation"
             let-isCustom="isCustom">
    <ng-template [ngIf]="isCustom"
                 [ngIfElse]="defaultProps">
        <ng-container [ngTemplateOutlet]="fieldsTemplate"
                      [ngTemplateOutletContext]="{ data: data, isCustom: true, group: group, item: item }">
        </ng-container>
    </ng-template>
    <ng-template #defaultProps>

        <ng-template ngFor
                     let-item
                     [ngForOf]="getList(group.name)"
                     let-j="index">
            <ng-container [ngTemplateOutlet]="fieldsTemplate"
                          [ngTemplateOutletContext]="{ data: data, isCustom: false, group: group, j: j, item: item }">
            </ng-container>
        </ng-template>
    </ng-template>

    <ng-template #fieldsTemplate
                 let-item="item"
                 let-data="data"
                 let-j="index"
                 let-isCustom="isCustom">
        <div class="topic-full-screen-accordion-pane-container-property__container"
             *ngIf="data.visibilityCriteria[item?.ID] || isCustom">
            <span class="topic-full-screen-accordion-pane-container-property__label">{{item?.DefaultCaption}}
            </span>
            <text-field [disabled]="item.ReadOnlyValue || topicDisabled || data.readOnlyCriteria[item?.ID]"
                        *ngIf="((item?.Validation?.toUpperCase() == 'TEXT') && (item.WordWrap == false))"
                        [required]="enforceRequiredFieldsOnCreate && item.Required"
                        [tabindex]="j"
                        [textToHighlight]="searchString"
                        showLinks
                        [label]="item.DefaultCaption"
                        (changed)="updateTopic($event, item.ID)"
                        [value]="data.get(item.ID)">
            </text-field>
            <st-text-area [disabled]="item.ReadOnlyValue || topicDisabled || data.readOnlyCriteria[item?.ID]"
                          [textToHighlight]="searchString"
                          *ngIf="((item.Validation.toUpperCase() == 'TEXT') && (item.WordWrap == true))"
                          [required]="enforceRequiredFieldsOnCreate && item.Required"
                          [tabindex]="j"
                          showLinks
                          (changed)="updateTopic($event, item.ID)"
                          [label]="item.DefaultCaption"
                          [value]="data.get(item.ID)"></st-text-area>
            <combo-box [disabled]="item.ReadOnlyValue || topicDisabled || data.readOnlyCriteria[item?.ID]"
                       [required]="enforceRequiredFieldsOnCreate && item.Required"
                       [tabindex]="j"
                       [label]="item.DefaultCaption"
                       [addEmptyOption]="!item.Required"
                       *ngIf="(item.Validation.toUpperCase() == 'COMBOBOX')"
                       [value]="data.get(item.ID)"
                       (changed)="updateTopic($event, item.ID)"
                       [itemList]="globalTablesService.getListItems(item.ID, item.List)">
            </combo-box>
            <check-list [disabled]="item.ReadOnlyValue || topicDisabled || data.readOnlyCriteria[item?.ID]"
                        [required]="enforceRequiredFieldsOnCreate && item.Required"
                        [tabindex]="j"
                        *ngIf="(item.Validation.toUpperCase() == 'CHECKLIST')"
                        [value]="getCheckListValue(item.ID)"
                        (changed)="updateTopic($event, item.ID)"
                        [label]="item.DefaultCaption"
                        [itemList]="globalTablesService.getListItems(item.ID, item.List)"></check-list>
            <check-box [disabled]="item.ReadOnlyValue || topicDisabled || data.readOnlyCriteria[item?.ID]"
                       [tabindex]="j"
                       [label]="item.DefaultCaption"
                       (changed)="updateTopic($event, item.ID)"
                       *ngIf="(item.Validation.toUpperCase() == 'CHECKBOX')"
                       [value]="data.get(item.ID)">
            </check-box>
            <date-picker [disabled]="item.ReadOnlyValue || topicDisabled || data.readOnlyCriteria[item?.ID]"
                         *ngIf="item.Validation.toUpperCase() == 'DATE'"
                         [required]="enforceRequiredFieldsOnCreate && item.Required"
                         [tabindex]="j"
                         [min]="getMinDate(item.ID)"
                         [label]="item.DefaultCaption"
                         (changed)="updateTopic($event, item.ID)"
                         [value]="getDateTimeValue(item.ID)">
            </date-picker>
            <date-time-picker [disabled]="item.ReadOnlyValue || topicDisabled || data.readOnlyCriteria[item?.ID]"
                              *ngIf="(item.Validation.toUpperCase() == 'TIME' ||
                                                                             item.Validation.toUpperCase() == 'MOSDATETIME')"
                              [required]="enforceRequiredFieldsOnCreate && item.Required"
                              [tabindex]="j"
                              [min]="getMinDate(item.ID)"
                              [label]="item.DefaultCaption"
                              (changed)="updateTopic($event, item.ID)"
                              [value]="getDateTimeValue(item.ID)">
            </date-time-picker>
            <date-time-range [disabled]="item.ReadOnlyValue || topicDisabled || data.readOnlyCriteria[item?.ID]"
                             [required]="enforceRequiredFieldsOnCreate && item.Required"
                             [tabindex]="j"
                             [label]="item.DefaultCaption"
                             (changed)="updateTopic($event, item.ID)"
                             *ngIf="item.Validation.toUpperCase() == 'DATETIMERANGE'"
                             [value]="getDateRangeValue(item.ID)">
            </date-time-range>
            <staff-id-list-multiple [disabled]="item.ReadOnlyValue || topicDisabled || data.readOnlyCriteria[item?.ID]"
                                    [required]="enforceRequiredFieldsOnCreate && item.Required"
                                    [tabindex]="j"
                                    (changed)="updateTopic($event, item.ID)"
                                    *ngIf="(item.Validation.toUpperCase() == 'STAFFIDLIST')"
                                    [label]="item.DefaultCaption"
                                    [value]="getStaffIdValue(item.ID)">
            </staff-id-list-multiple>
            <tree [disabled]="item.ReadOnlyValue || topicDisabled || data.readOnlyCriteria[item?.ID]"
                  [required]="enforceRequiredFieldsOnCreate && item.Required"
                  [tabindex]="j"
                  (changed)="updateTopic($event, item.ID)"
                  *ngIf="(item.Validation.toUpperCase() == 'TREE')"
                  [value]="data.get(item.ID)"
                  [label]="item.DefaultCaption"
                  [itemList]="globalTablesService.getlistItemsForTree(item.List)">
            </tree>
            <ng-template [ngIf]="(item.Validation.toUpperCase() == 'ADDRESS')">
                <ng-template [ngIf]="item.ComplexPropInnerId">
                    <text-field [placeholder]="item.DefaultCaption"
                                [label]="item.DefaultCaption"
                                [required]="enforceRequiredFieldsOnCreate && item.Required"
                                [disabled]="topicDisabled || item.ReadOnlyValue || data.readOnlyCriteria[item?.ID]"
                                floating
                                [textToHighlight]="searchString"
                                [value]="getInnerProp(item)"
                                (changed)="updateTopicAddresSubField($event , item, item.ComplexPropInnerId)">
                    </text-field>
                </ng-template>
                <ng-template [ngIf]="!item.ComplexPropInnerId">
                    <address-form [width]="'100%'"
                                  [required]="enforceRequiredFieldsOnCreate && item.Required"
                                  [disabled]="topicDisabled || item.ReadOnlyValue || data.readOnlyCriteria[item?.ID]"
                                  [tabindex]="j"
                                  [label]="item.DefaultCaption"
                                  [value]="data.get(item.ID)"
                                  (changed)="updateTopic($event , item.ID)"></address-form>
                </ng-template>
            </ng-template>
        </div>
    </ng-template>

</ng-template>
